import { useEffect } from 'react';
import PageSeo from '@/seo/PageSeo';
import AboutScrollytelling from '@/components/Scrollytelling/AboutScrollytelling';

export default function Scrollytelling() {
  useEffect(() => {
    const popovers = document.querySelectorAll('.popover');
    popovers.forEach(el => ((el as HTMLElement).style.display = 'none'));
  }, []);

  return (
    <>
      <PageSeo
        title="Curated Gene-Disease Knowledge Platform | DISGENET"
        description="DISGENET is a curated gene-disease association database and biomedical knowledge graph with evidence scores, variant-disease data and full provenance."
        path="/about"
      />
      <main className="min-h-screen" role="main">
        <AboutScrollytelling />
      </main>
    </>
  );
}
